<template>
  <div class="container" v-if="empresa._id">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Afiliados - {{empresa.name}}</h3>
            </div>
            <div class="col-auto">
              <b-button @click="$router.push({name: 'AfiliadoForm', query: {empresa: empresa._id}})">Novo</b-button>
            </div>
            <div class="col-auto">
              <b-button @click="voltar">Voltar</b-button>
            </div>
          </div>
        </div>
        <div class="element-box">
          <div class="row">
            <b-col class="my-1">
              <b-pagination
                  v-if="totalRows > 10"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="fill"
                  size="sm"
                  class="my-0"
              ></b-pagination>
            </b-col>
          </div>
          <b-table striped hover
                   ref="listAfiliado"
                   :current-page="currentPage"
                   :per-page="perPage" :items="afiliados" :fields="fields"
                   show-empty emptyText="Não há afiliados cadastrados.">
            <div slot="table-busy" class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Carregando...</strong>
            </div>
            <template slot="[status]" slot-scope="row">
              <b-badge v-if="row.item.status === 'ATIVO'"
                       variant="success">
                <i title="Ativo"  class="fa fa-check"></i>
              </b-badge>
              <b-badge v-else>
                <i title="Inativo" variant="danger" class="fa fa-minus"></i>
              </b-badge>
            </template>
            <template slot="[actions]" slot-scope="row">
              <b-button variant="warning" size="sm"
                        @click="$router.push({name: 'AfiliadoForm', query: {id: row.item._id}})">
                <i class="fa fa-edit"></i>
              </b-button>
              <b-button variant="warning" size="sm"
                        title="Atualizar Status"
                        @click="updateStatusVindi(row.item)">
                <i class="fa fa-redo"></i>
              </b-button>
              <b-button variant="success" size="sm"
                        title="Habilitar Afiliado"
                        v-if="row.item.status === 'INATIVO'"
                        @click="ativar(row.item)">
                <i class="fa fa-check"></i>
              </b-button>
              <b-button variant="danger" size="sm"
                        v-if="row.item.status === 'ATIVO'"
                        title="Desabilitar Afiliado"
                        @click="desativar(row.item)">
                <i class="fa fa-minus"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AfiliadoList",
  async created() {
    this.empresa = await axios.get(`/api/juridica/${this.$route.query.empresa}`)
        .then(response => response.data)
  },
  data: () => ({
    empresa: null,
    totalRows: 1,
    currentPage: 1,
    perPage: 10,
    filtro: {},
    fields: [
      {key: 'vindi.affiliate.id', label: 'Codigo'},
      {key: 'nome', label: 'Nome'},
      {key: 'email', label: 'Email'},
      {key: 'status', Label: 'Situação'},
      {key: 'actions', label: '', class: 'text-center'}
    ]
  }),
  methods: {
    voltar() {
      window.history.back();
    },
    afiliados(ctx) {
      const filtro = _.cloneDeep(this.filtro)
      filtro.empresa = this.empresa._id
      filtro.limit = ctx.perPage;
      filtro.page = ctx.currentPage;

      const promise = axios.get('/api/afiliados/paginate', {
        params: {
          ...filtro,
          sort: 'codigo'
        }
      })

      return promise.then(response => {
        let result = response.data;
        this.totalRows = result.totalCount;

        const items = result.data;
        return items || []
      })
    },
    async updateStatusVindi(afiliado) {
      try {
        this.$store.dispatch('setLoading', true);

        await axios.post('/api/afiliados/updateStatus', {
          juridica: this.empresa._id,
          id: afiliado._id
        })

        this.$root.$emit('bv::refresh::table', 'listAfiliado')

      } catch (e) {
        Alert('Falha ao atualizar status do afiliado')
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    }
  }
}

</script>

<style scoped>

</style>